import { google } from './google';

export const STORAGE_FEES = `${google.YOUTUBE_URL}/embed/ljlZyp-Jlik`;
export const STORE_PRECIOUS_METALS = `${google.YOUTUBE_URL}/embed/cUQsleW-q5k`;
export const SELL_STORED_METALS = `${google.YOUTUBE_URL}/embed/KeXPsKo9zjg`;
export const SHIP_PRECIOUS_METALS = `${google.YOUTUBE_URL}/embed/uUG-OSC9lR8`;
export const GA_BUY_SELL_STORE = `${google.YOUTUBE_URL}/embed/xQHGwd5-vzc`;
export const BUY_PRECIOUS_METALS = `${google.YOUTUBE_URL}/embed/HPzfmJq-sR8`;
export const USE_STORAGE_FEES = `${google.YOUTUBE_URL}/embed/ljlZyp-Jlik`;
